
import Vue from "vue";
import store from "@/store";
import router from "@/router";
import { validationMixin } from "vuelidate";
import { required, minLength, minValue } from "vuelidate/lib/validators";
import AppLoading from "@/components/UI/AppLoading.vue";

export default Vue.extend({
  name: "AdminEditProduct",
  mixins: [validationMixin],
  components: { AppLoading },
  data() {
    return {
      id: "",
      chosenFile: "" as string | FormData,
      chosenFiles: "" as string | FormData,
      defaultImage: require("@/assets/img/default-product.jpg"),
      sizeList: [
        {
          title: "2",
          value: 2,
        },
        {
          title: "4",
          value: 4,
        },
        {
          title: "6",
          value: 6,
        },
        {
          title: "8",
          value: 8,
        },
        {
          title: "10",
          value: 10,
        },
        {
          title: "12",
          value: 12,
        },
        {
          title: "14",
          value: 14,
        },
        {
          title: "16",
          value: 16,
        },
        {
          title: "18",
          value: 18,
        },
        {
          title: "20",
          value: 20,
        },
        {
          title: "22",
          value: 22,
        },
        {
          title: "24",
          value: 24,
        },
        {
          title: "26",
          value: 26,
        },
        {
          title: "28",
          value: 28,
        },
        {
          title: "30",
          value: 30,
        },
      ],

      colors: [
        {
          title: "خاکسنری",
          value: "#334155",
        },
        {
          title: "قرمز",
          value: "#991b1b",
        },
        {
          title: "نارنجی",
          value: "#b45309",
        },
        {
          title: "زرد",
          value: "#eab308",
        },
        {
          title: "سبز",
          value: "#15803d",
        },
        {
          title: "خاکستری",
          value: "#374151",
        },
        {
          title: "آسمانی",
          value: "#0ea5e9",
        },
        {
          title: "آبی",
          value: "#1d4ed8",
        },
        {
          title: "بنفش",
          value: "#7e22ce",
        },
        {
          title: "صورتی",
          value: "#be185d",
        },
        {
          title: "مشکی",
          value: "#000000",
        },
        {
          title: "سفید",
          value: "#ffffff",
        },
      ],
    };
  },
  methods: {
    editProduct() {
      // store.dispatch("admin/editProduct", {
      //   id: this.id,
      //   formData: { image: this.chosenFile, images: this.chosenFiles },
      // });
      const data = {
        id: this.id,
        image: this.chosenFile,
        images: this.chosenFiles,
      };
      store.dispatch("admin/postEditLandingProduct", data);
    },
    editProductImage(e: any): void {
      const file = e.target.files[0];
      if (file) {
        const fileReader = new FileReader();

        fileReader.onload = (event) => {
          store.dispatch(
            "admin/updateSelectedLandingProductImage",
            event?.target?.result
          );
        };
        fileReader.readAsDataURL(file);

        // save choosed file
        let formData = new FormData();
        formData.append("image", file);
        this.chosenFile = formData;
      }
    },
    uploadImages(files: any): void {
      let formData = new FormData();

      for (let fileIndex in files) {
        const file = files[fileIndex];

        formData.append("images", file);
      }

      this.chosenFiles = formData;
    },
    cancel(): void {
      router.push({ name: "admin-all-landing-products" });
    },

    Image(image: string): string {
      if (image.length < 280) {
        return "https://webapi.vip-chef.ir/images/landing/" + image;
      } else {
        return image;
      }
    },
  },
  computed: {
    productDetails() {
      return store.state.admin.productData;
    },
    categories(): any[] {
      const categories = store.state.admin.landing.categories;
      let items: any[] = [];
      categories.forEach((category: any) => {
        const item = {
          title: category.persianTitle,
          value: category["_id"],
        };
        items.push(item);
      });
      return items;
    },

    types(): any[] {
      const types = store.state.admin.landing.types;
      let items: any[] = [];
      types.forEach((category: any) => {
        const item = {
          title: category.title,
          value: category._id,
        };
        items.push(item);
      });
      return items;
    },
    name: {
      get(): string {
        return store.state.admin.landing.selectedLandingProduct.name;
      },
      set(value: string): void {
        store.dispatch("admin/updateSelectedLandingProductName", value);
      },
    },
    nameError(): string[] {
      const errors: string[] = [];
      if (!this.$v.name?.$dirty) {
        return errors;
      }
      !this.$v.name.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    category: {
      get(): string {
        return store.state.admin.landing.selectedLandingProduct.category;
      },
      set(value: string): void {
        store.dispatch("admin/updateSelectedLandingProductCategory", value);
      },
    },
    categoryError(): string[] {
      const errors: string[] = [];
      if (!this.$v.category?.$dirty) {
        return errors;
      }
      !this.$v.category.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    type: {
      get(): string {
        return store.state.admin.landing.selectedLandingProduct.type;
      },
      set(value: string): void {
        store.dispatch("admin/updateSelectedLandingProductType", value);
      },
    },
    typeError(): string[] {
      const errors: string[] = [];
      if (!this.$v.type?.$dirty) {
        return errors;
      }
      !this.$v.type.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    amount: {
      get(): number | null {
        return Number(store.state.admin.landing.selectedLandingProduct.amount);
      },
      set(value: number): void {
        store.dispatch(
          "admin/updateSelectedLandingProductAmount",
          Number(value)
        );
      },
    },
    amountError(): string[] {
      const errors: string[] = [];
      if (!this.$v.amount?.$dirty) {
        return errors;
      }
      !this.$v.amount.minLength && errors.push("حداقل 4 رقم");
      !this.$v.amount.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    description: {
      get(): string {
        return store.state.admin.landing.selectedLandingProduct.description;
      },
      set(value: string): void {
        store.dispatch("admin/updateSelectedLandingProductDescription", value);
      },
    },

    size: {
      get(): string {
        return store.state.admin.landing.selectedLandingProduct.sizes;
      },
      set(value: string): void {
        store.dispatch(
          "admin/updateSelectedLandingProductDescriptionSizes",
          value
        );
      },
    },
    sizeError(): string[] {
      const errors: string[] = [];
      if (!this.$v.size?.$dirty) {
        return errors;
      }
      !this.$v.size.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    color: {
      get(): string {
        return store.state.admin.landing.selectedLandingProduct.colors;
      },
      set(value: string): void {
        store.dispatch(
          "admin/updateSelectedLandingProductDescriptionColors",
          value
        );
      },
    },
    colorError(): string[] {
      const errors: string[] = [];
      if (!this.$v.color?.$dirty) {
        return errors;
      }
      !this.$v.color.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },

    descriptionError(): string[] {
      const errors: string[] = [];
      if (!this.$v.description?.$dirty) {
        return errors;
      }
      !this.$v.description.required && errors.push("تکمیل این فیلد الزامی است");
      return errors;
    },
    isLoading(): boolean {
      return store.state.app.loading;
    },
  },
  created() {
    const id = this.$route.query.id;

    if (!id) {
      // set snackbar
      store.commit("app/showSnackbar", {
        message: "ابتدا یک محصول جهت ویرایش انتخاب کنید",
        status: 400,
      });

      // move to the main admin page
      router.push({ name: "admin-all-landing-products" });
    } else {
      this.id = id as string;
      store.dispatch("admin/getLandingProductById", id);
    }
  },
  validations: {
    name: {
      required,
    },
    category: {
      required,
    },
    amount: {
      required,
      minLength: minLength(4),
    },
    size: {
      required,
    },
    color: {
      required,
    },
    type: {
      required,
    },
    description: {
      required,
    },
  },
});
